export default __webpack_public_path__ + "static/media/DriverManual.b3e96380.pdf";